import React from "react";
import { Paper, Typography, Box, Chip } from "@mui/material";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import TodayIcon from "@mui/icons-material/Today";

const cards = [
  {
    title: "Total Invoices",
    icon: <ReceiptLongIcon fontSize="medium" color="primary" />,
    tone: "#2563eb",
    bg: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
    caption: "All invoices processed",
    chip: "Workspace",
  },
  {
    title: "Today’s Invoices",
    icon: <TodayIcon fontSize="medium" color="secondary" />,
    tone: "#7c3aed",
    bg: "linear-gradient(135deg, #faf5ff 0%, #ede9fe 100%)",
    caption: "Created today",
    chip: "Today",
  },
];

const DashboardCards = ({ stats }) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(180px, 1fr))" },
      gap: 2,
      minWidth: { xs: "100%", md: 420 },
      flex: "0 1 520px",
    }}
  >
    {cards.map((card) => (
      <Paper
        key={card.title}
        elevation={0}
        sx={{
          p: 2,
          minHeight: 132,
          borderRadius: 2,
          border: "1px solid rgba(148, 163, 184, 0.22)",
          bgcolor: "#ffffff",
          boxShadow: "0 14px 32px rgba(15, 23, 42, 0.07)",
          position: "relative",
          overflow: "hidden",
          "&:before": {
            content: '""',
            position: "absolute",
            inset: 0,
            background: card.bg,
            opacity: 0.82,
          },
        }}
      >
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 1 }}>
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: 2,
                bgcolor: "rgba(255,255,255,0.78)",
                color: card.tone,
                display: "grid",
                placeItems: "center",
                boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.7)",
                "& svg": { color: card.tone },
              }}
            >
              {card.icon}
            </Box>
            <Chip
              size="small"
              label={card.chip}
              sx={{ bgcolor: "rgba(255,255,255,0.72)", color: "#334155", fontWeight: 800 }}
            />
          </Box>
          <Typography sx={{ fontSize: 13, color: "#475569", fontWeight: 900, mt: 2 }}>
            {card.title}
          </Typography>
          <Typography sx={{ fontSize: 28, fontWeight: 950, color: "#0f172a", lineHeight: 1.08, mt: 0.45 }}>
            {card.title === "Today’s Invoices" ? stats?.today_count ?? "-" : stats?.total_count ?? "-"}
          </Typography>
          <Typography sx={{ color: "#64748b", fontSize: 12.5, mt: 0.75, fontWeight: 700 }}>
            {card.caption}
          </Typography>
        </Box>
      </Paper>
    ))}
  </Box>
);

export default DashboardCards;
